module.exports = __webpack_public_path__ + "static/media/album.c890e7e4.svg";